if(typeof BSS_B2B != undefined) {
    if(window.location.pathname.includes("/account/register")) {
     
        let passwordField = $(".password-field");
        let rfField = $("#bss-b2b-registration-form-render");
        if(passwordField && rfField) {
            passwordField.after(rfField)
        }
    }
}